<template>
  <div class="container">
    <div >
      <router-link :to="{name: 'emailTemplateEditor', params: {emailTemplateId: 'new'}}">Yeni Olustur</router-link>
    </div>
    <div v-bind:key="idx" v-for="(emailTemplate, idx) in emailTemplates" >
      <div>
        <router-link :to="{name: 'emailTemplateEditor', params: {emailTemplateId: emailTemplate._id}}">{{ emailTemplate.name }}</router-link>
        <button type="button" v-on:click="deleteEmailTemplate( emailTemplate._id )">Delete</button>
        <button type="button" v-on:click="createPdf( emailTemplate._id, '615440700611305d6668c8a6' )">Create Pdf</button>
        <button type="button" v-on:click="printPdf( emailTemplate._id, '615440700611305d6668c8a6' )">Print Pdf</button>
        <button type="button" v-on:click="sendEmail( emailTemplate._id, '615440700611305d6668c8a6' )">Send Email</button>
      </div>
    </div>
  </div>
</template>

<script>
 import axios from "axios";
 import {mapState} from 'vuex'
 const qs = require('qs')
 export default {
   name: 'EmailTemplates',
   data() {
     return {
       emailTemplates: []
     }
   },
   computed: {
     ...mapState([
       'baseUrl'
     ])
   },
   methods: {
     getEmailTemplates() {
       axios({
         method:'POST',
         url:'/getEmailTemplates',
         baseURL: this.baseUrl,
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           this.emailTemplates = res.data.content.email_templates;
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
     deleteEmailTemplate(templateId) {
       axios({
         method:'POST',
         url:'/deleteEmailTemplates',
         baseURL: this.baseUrl,
         data: {templateIds: [templateId]},
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           console.log("delete: OK")
           this.getEmailTemplates()
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
     createPdf(templateId, offerId) {
       axios({
         method:'POST',
         url:'/createOfferPdf',
         baseURL: this.baseUrl,
         data: {
           templateId: templateId,
           offerId: offerId
         },
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status === "OK" ){
           console.log(res)
           window.open(res.data.url, '_blank')
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
     sendEmail() {
       var data = {
         action: 'login',
         token: 'MDHCP6GC7PKNT466L2ZUNODMX62W8H',
         emailAddress: ['askin@askin.ws', 'askin@deep-net.cf'],
         subject: "Teklifiniz Oluşturuldu",
         message: "Buraya mail icerigi gelecek",
         attachments: [
           'https://live.minimumcrm.com/embedded-pdf/2021/09/30/tmpexn_hr4z.html.pdf',
           'https://live.minimumcrm.com/embedded-pdf/2021/09/30/tmp97j6i0k1.html.pdf'
         ]
       }
       var requestParameters = qs.stringify(data)
       var emailUrl = 'https://live.minimumcrm.com/mail-client/rclogin.php'
       var redirectUrl = `${emailUrl}?${requestParameters}`
       console.log(redirectUrl)
       /* window.open(redirectUrl, '_blank') */
       window.open(redirectUrl)
     },
     printPdf(templateId, offerId) {
       axios({
         method:'POST',
         url:'/createOfferPdf',
         baseURL: this.baseUrl,
         data: {
           templateId: templateId,
           offerId: offerId
         },
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status === "OK" ){
           var id = "iframe", frame = document.createElement("iframe");
           frame.setAttribute("id", id);
           frame.setAttribute("name", "printframe");
           frame.setAttribute("hidden", true);
           document.body.appendChild(frame);
           frame.onload = function() {
             setTimeout(function() {
               printframe.print()
             },2000)
           }
           /* frame.setAttribute("src", res.data.url); */
           frame.setAttribute("src", res.data.relative_url);
         } else {
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     }
   },
   mounted() {
     this.getEmailTemplates()
   }
 }
</script>